import { create } from 'zustand';

/*
  Open state of the Cmd+K palette, so the top bar search field (PageWrapper), the keyboard shortcut and any other
  component can open it. The element that had focus is remembered at the moment of opening (the palette's input takes
  focus right after) and gets it back on close; never the top bar field, since focusing that opens the palette again.
*/
let focusBeforeOpen = null;

function rememberFocus() {
  const element = typeof document === 'undefined' ? null : document.activeElement;
  focusBeforeOpen = element && element !== document.body && !element.closest?.('.Polaris-TopBar-SearchField') ? element : null;
}

export function takeFocusBeforeOpen() {
  const element = focusBeforeOpen;
  focusBeforeOpen = null;
  return element;
}

export const useCommandPaletteStore = create((set) => ({
  isOpen: false,
  initialQuery: '',
  open: (initialQuery = '') => {
    rememberFocus();
    set({ isOpen: true, initialQuery: typeof initialQuery === 'string' ? initialQuery : '' });
  },
  close: () => set({ isOpen: false, initialQuery: '' }),
  toggle: () =>
    set((state) => {
      if (!state.isOpen) rememberFocus();
      return { isOpen: !state.isOpen, initialQuery: '' };
    })
}));

const isMac = () => {
  try {
    return /mac|iphone|ipad/i.test(navigator.userAgentData?.platform || navigator.platform || '');
  } catch {
    return false;
  }
};

export const MOD_KEY = isMac() ? '⌘' : 'Ctrl';
export const SHORTCUT_LABEL = isMac() ? '⌘K' : 'Ctrl+K';

// phones and tablets get no keyboard hint in the top bar field
export const HAS_KEYBOARD = (() => {
  try {
    return window.matchMedia('(pointer: fine)').matches;
  } catch {
    return true;
  }
})();
